import React from "react";
import "./Loader.css"

const Loader = () => {
  return (
    <div className="container-loader">
    <div className="loading">
      <span>Loading</span>
    </div>
  </div>
  );
};

export default Loader;
